var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [(_vm.item.tooltip) ? _c('Tooltip', {
    attrs: {
      "placement": "right",
      "transfer": ""
    }
  }, [_c('div', {
    staticStyle: {
      "white-space": "normal"
    },
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n            " + _vm._s(_vm.item.tooltip) + "\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [(_vm.item.required) ? _c('div', {
    staticStyle: {
      "margin-right": "4px",
      "color": "red"
    }
  }, [_vm._v("*")]) : _vm._e(), _vm._v("\n            " + _vm._s(_vm.item.name) + "\n            "), _c('Icon', {
    staticStyle: {
      "margin-left": "4px",
      "opacity": "0.4"
    },
    attrs: {
      "type": "ios-help-circle"
    }
  })], 1)]) : _c('div', [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [(_vm.item.required) ? _c('div', {
    staticStyle: {
      "margin-right": "4px",
      "color": "red"
    }
  }, [_vm._v("*")]) : _vm._e(), _vm._v("\n            " + _vm._s(_vm.item.name) + "\n        ")])])], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0127557c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0127557c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/FormItemLabel.vue
// module id = vRuk
// module chunks = 142